import React from 'react';
import RegistryCard from './RegistryCard';

const RegistryList = ({ entries, kinds, theme, styles, onEntryClick, onDelete, onDrillInto, loading, error }) => {
  if (loading) return <div style={{ color: theme.toolbar.text }}>Загрузка…</div>;
  if (error) return <div style={{ color: '#ff6b6b' }}>Ошибка: {error}</div>;
  if (entries.length === 0) return <div style={{ color: theme.toolbar.text, opacity: 0.6 }}>Ничего не найдено</div>;

  return (
    <div style={styles.grid}>
      {entries.map((entry) => (
        <RegistryCard
          key={entry.id}
          entry={entry}
          kinds={kinds}
          theme={theme}
          styles={styles}
          onClick={() => onEntryClick(entry)}
          onDelete={onDelete}
          onDrillInto={onDrillInto}
        />
      ))}
    </div>
  );
};

export default RegistryList;
